//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { gql } from 'graphql-tag'

const ME_QUERY = gql`
  query {
    me {
      id
      trialReactivationDate
    }
  }
`

export default {
  name: 'Subscriptions',
  scrollToTop: true,
  data() {
    return {
      client_secret: null,
      user: {}
    }
  },
  computed: {
    account() {
      return this.$store.get('user/user') || null
    },
    language() {
      return this.$store.get('language/locale') || 'en'
    }
  },
  watch: {
    async language() {
      await this.getClientSecret()
    },
    async account() {
      await this.getClientSecret()
    }
  },
  async mounted() {
    const {
      data: { me }
    } = await this.$apollo.query({
      query: ME_QUERY
    })

    this.user = me

    setTimeout(() => {
      this.$nuxt.$emit('topbanner', {
        isShow: false
      })
      this.setBreadcrumb({ isShow: false })
      console.log('mounted -> mounted:')
    }, 1)

    await this.getClientSecret()
    setInterval(async () => await this.getClientSecret(), 1800000)
  },
  beforeDestroy() {
    this.$nuxt.$emit('topbanner', {
      isShow: true
    })
  },
  methods: {
    async getClientSecret() {
      if (!this.account) return

      this.client_secret = undefined
      const data = await this.$axios.$get(`${this.$config.apiRestUrl}/order/create-subscription-table-session`)
      this.client_secret = data.client_secret
    },
    forceRegister() {
      this.$nuxt.$emit('registerAndCheckout', null)
    },
    getPricingTable() {
      const pricingTbl = {
        en: {
          withTrial: this.$config.pricingTableEng,
          withoutTrial: this.$config.pricingTableEngNoTrial
        },
        nl: {
          withTrial: this.$config.pricingTableNld,
          withoutTrial: this.$config.pricingTableNldNoTrial
        }
      }

      let pricing = pricingTbl[this.language].withTrial

      const { trialReactivationDate } = this.user || {}
      if (!trialReactivationDate) return pricing

      const isAllowedTrial = this.$dayjs(trialReactivationDate).isBefore(this.$dayjs())
      if (!isAllowedTrial) {
        pricing = pricingTbl[this.language].withoutTrial
      }

      return pricing
    }
  }
}
